import React from 'react'
import Sidebar from "../../components/sidebar/Sidebar"
import Navbar from "../../components/navbar/Navbar"
import ProductTable from "../../components/datatable/productTable"
import ProductList from "../../components/table/latestProduct";
import "./list.scss"

export default function product() {
  return (
      <>    
          <div className="list">
              <Sidebar/>
              <div className="listContainer">
                  <Navbar/>
                  <ProductTable />
                  <div className="bottom">
                      <br />
                      <hr />
                      <h4 className="title">Last Products Added</h4>
                      <ProductList />
                  </div>
              </div>

          </div>     
      </>
  )
}
